// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pre-work-check-target label {\n  padding: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
